var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-card",
    { staticClass: "mb-20 px-4", attrs: { flat: "" } },
    [
      _c("v-divider"),
      _vm._v(" "),
      _c(
        "v-row",
        { staticClass: "my-4 px-4" },
        [
          _c(
            "v-icon",
            { staticClass: "mr-2", attrs: { color: "black", size: "25" } },
            [_vm._v("house")]
          ),
          _vm._v(" "),
          _c("h3", { staticClass: "font-weight-regular text-uppercase" }, [
            _vm._v("ENDEREÇOS")
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c("addresses", { attrs: { accountable: _vm.accountable } })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-32f0b613", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-32f0b613","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Customers/Components/Addresses.vue
// module id = null
// module chunks = 